export default __webpack_public_path__ + "2a12e4c82b62db7588f7ad91e79fcbab.svg";